import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import { HttpRequestRetryPolicyService, HttpRequestService } from './http';

/**
 * Service to generate random unique identifiers
 *
 * @export
 */
@Injectable({
    providedIn: 'root',
})
export class MfaAuthService {
    constructor(
        private httpService: HttpRequestService,
        private httpRetryPolicyService: HttpRequestRetryPolicyService,
    ) {}

    async sendCode(userTenant: string, phoneNumber: string): Promise<any> {
        const { multifactorConfig } = environment;

        const route = multifactorConfig.SEND_CODE_ROUTE(multifactorConfig.PLATFORM_BASE_URL);

        const tenantHeader: Map<string, string> = new Map<string, string>();
        tenantHeader.set('x-tenant', userTenant);

        await this.httpService.headersService.setHttpHeaders(tenantHeader);

        const response = await this.httpService.post<any>(
            `${route}`,
            {
                channel: 'sms',
                to: phoneNumber
            },
            this.httpRetryPolicyService.noRetryPolicy(),
        );

        await this.httpService.headersService.resetHttpHeaders();

        return response;
    }

    async validateCode(userTenant: string, verificationCode: string, phoneNumber: string): Promise<any> {
        const { multifactorConfig } = environment;

        const route = multifactorConfig.VALIDATE_CODE_ROUTE(multifactorConfig.PLATFORM_BASE_URL);

        const tenantHeader: Map<string, string> = new Map<string, string>();
        tenantHeader.set('x-tenant', userTenant);

        await this.httpService.headersService.setHttpHeaders(tenantHeader);

        const response = await this.httpService.post<any>(
            `${route}`,
            {
                code: verificationCode,
                to: phoneNumber,
            },
            this.httpRetryPolicyService.noRetryPolicy(),
        );

        await this.httpService.headersService.resetHttpHeaders();
        
        return response;
    }
}

